let nextActionStartMarkId = 0;

/** Measure one user action from click to settled result. Local only; never sent anywhere. */
export function measureAction<T>(name: string, run: () => Promise<T>): Promise<T> {
  let startMark: string | null = null;
  if (typeof performance !== "undefined") {
    startMark = `action:${name}:start:${++nextActionStartMarkId}`;
    try {
      performance.mark(startMark);
    } catch {
      startMark = null;
    }
  }

  const finishMeasurement = () => {
    if (startMark === null) return;

    const measure = () => {
      if (startMark !== null && typeof performance !== "undefined") {
        try {
          performance.measure(`action:${name}`, startMark);
        } catch {
          // Timing is best-effort and must never change the action's outcome.
        } finally {
          try {
            performance.clearMarks(startMark);
          } catch {
            // The action result remains authoritative if the browser rejects a mark cleanup.
          }
        }
      }
    };

    if (typeof requestAnimationFrame === "function") {
      try {
        requestAnimationFrame(measure);
        return;
      } catch {
        // Fall through to the best-effort immediate measurement.
      }
    }
    measure();
  };

  const action = run();
  // Keep the mutation's original promise as the result so telemetry cannot
  // add a turn to the caller's state updates or change its rejection.
  void action.then(finishMeasurement, finishMeasurement);
  return action;
}
